'use strict';

module.exports = ['DISALLOWED', 'ALLOWED', 'REQUIRED'];